import request from '@/request/ts-index2';
var UnicomApi;
(function (UnicomApi) {
    UnicomApi["qrySubedProductsNoToken"] = "/unicom/qrySubedProductsNoToken";
    UnicomApi["settingRingOnePointMon"] = "/unicom/settingRingOnePointMon";
    UnicomApi["onePointProductMon"] = "/unicom/onePointProductMon";
    UnicomApi["unSubProductNoToken"] = "/unicom/unSubProductNoToken";
    UnicomApi["webLog"] = "/unicom/weblog";
})(UnicomApi || (UnicomApi = {}));
export const qrySubedProductsNoToken = (data) => {
    return request.post(UnicomApi.qrySubedProductsNoToken, data);
};
export const settingRingOnePointMon = (data) => {
    return request.post(UnicomApi.settingRingOnePointMon, data);
};
export const onePointProductMon = (data) => {
    return request.post(UnicomApi.onePointProductMon, data);
};
export const unSubProductNoToken = (phone) => {
    return request.post(UnicomApi.unSubProductNoToken, { phone });
};
export const unicomWebLog = (data) => {
    return request.post(UnicomApi.webLog, data);
};
